import { Component, computed, inject, input } from '@angular/core';
import { Badge, Button } from 'excellence-ui';
import { OrganizationsStore } from '../../../organizations/store/organizations.store';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-dashboard-parse-request-alert',
  imports: [Badge, Button, RouterLink, TranslocoPipe],
  templateUrl: './dashboard-parse-request-alert.html',
})
export class DashboardParseRequestAlert {
  private organizationsStore = inject(OrganizationsStore);

  organizationId = input.required<string>();

  private childStatsState = computed(
    () => this.organizationsStore.entities()[this.organizationId()]?.childStats ?? null,
  );

  protected totalActiveParseRequests = computed(
    () => this.childStatsState()?.data?.totalActiveParseRequests ?? 0,
  );
}
